import { useEffect, useRef } from 'react';

interface UseAutoFocusOptions {
  select?: boolean;
}

type FocusableInput = HTMLInputElement | HTMLTextAreaElement;

export function useAutoFocusInput<T extends FocusableInput = FocusableInput>({
  select = true,
}: UseAutoFocusOptions = {}) {
  const ref = useRef<T>(null);

  useEffect(() => {
    ref.current?.focus();

    if (select) {
      ref.current?.select();
    }
    // `select` is only read on mount, reacting to it would re-focus on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return ref;
}
